import { formatDate } from "date-fns";
import DatePicker from "react-date-picker";
import { Control, Controller } from "react-hook-form";

interface Props{
    name: string;
    control: Control<any>;
    placeholder?: string;
    label?: string;
    defaultValue?: string | number;
    rules?: any;
    showLabel?: boolean;
    format?:string;
}
const BIDatePicker: React.FC<Props> = ({showLabel, label, name, control, rules, format}) => {
    return(
        <div className="w-full">
            {showLabel && label && <label htmlFor={name}>{label}</label>}
            <Controller
                name={name}
                control={control}
                rules={rules}
                defaultValue={new Date()} // Set default value to null if no date is selected
                render={({ field, fieldState: { error } }) => (
                    <div>
                        <DatePicker
                            {...field}
                            format={format}
                            onChange={(date) => {
                                if(!date) {
                                    field.onChange('')
                                    return;
                                }
                                if (Array.isArray(date)) {
                                    const [startDate, endDate] = date;

                                    // Ensure both dates are valid before formatting
                                    if (startDate && endDate) {
                                        const formattedStartDate = formatDate(startDate, format || 'y-MM-dd');
                                        const formattedEndDate = formatDate(endDate, format || 'y-MM-dd');
                                        const formattedDateRange = `${formattedStartDate}, ${formattedEndDate}`;
                                        field.onChange(formattedDateRange); // Return startDate, endDate
                                    } else {
                                        field.onChange(''); // If either date is missing, reset the value
                                    }
                                } else {
                                    // For single date selection
                                    const formattedDate = formatDate(date, format || 'y-MM-dd');
                                    field.onChange(formattedDate); // Pass the formatted single date
                                }
                            }}
                            value={field.value || null} // Ensure the value is either a Date or null
                        />

                        {error && <p className="text-red-500 text-[12px]">{error.message}</p>}
                    </div>
                )}
            />
        </div>
    )
}

export default BIDatePicker;